import axios from 'axios';
import { useAuthStore } from './auth-store';
export const api = axios.create({
    baseURL: '/api',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
});
api.interceptors.request.use((cfg) => {
    const token = useAuthStore.getState().accessToken;
    if (token) {
        cfg.headers = cfg.headers ?? {};
        cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
});
let refreshingPromise = null;
async function refreshAccess() {
    if (refreshingPromise)
        return refreshingPromise;
    const refresh = useAuthStore.getState().refreshToken;
    if (!refresh)
        throw new Error('no-refresh');
    refreshingPromise = axios
        .post('/api/auth/refresh', { refresh_token: refresh })
        .then((r) => {
        const { access_token, refresh_token, user } = r.data;
        useAuthStore.getState().setSession({ accessToken: access_token, refreshToken: refresh_token, user });
        return access_token;
    })
        .finally(() => {
        refreshingPromise = null;
    });
    return refreshingPromise;
}
api.interceptors.response.use((r) => r, async (err) => {
    const original = err.config;
    if (err.response?.status === 401 && !original._retried) {
        original._retried = true;
        try {
            const newToken = await refreshAccess();
            original.headers = original.headers ?? {};
            original.headers.Authorization = `Bearer ${newToken}`;
            return api.request(original);
        }
        catch {
            useAuthStore.getState().logout();
            window.location.href = '/login';
        }
    }
    return Promise.reject(err);
});
export function apiError(err) {
    const e = err;
    return (e?.response?.data?.error?.message ||
        e?.message ||
        'Terjadi kesalahan tak terduga');
}
